import 'bootstrap/js/src/index';
import 'lazysizes';
import * as selectric from 'selectric';

// @UNI-1
import { ReCaptcha }         from 'Core/ReCaptcha';
import { Navbar }            from 'Components/Navbar';
import { Infobar }           from 'Components/Infobar';
// import { Filters }           from 'Components/Filters';
// import { Sort }              from 'Components/Sort';
import { ValidationModule }  from 'Components/Validation/Validation';
import { LoginPanel }        from 'Components/LoginPanel';
// import { Cart }              from 'Components/Cart/Cart';
// import { CartOfferModule }   from 'Components/Cart/CartOffer';
import { Favourites }        from 'Components/Favourites';
// import { DepartmentsModule } from 'Components/Departments';
import { ProductAvailable }  from 'Components/ProductAvailable';
import { ResetPassword }     from 'Components/ResetPassword';
import { ScrollUpBtn }       from 'Components/ScrollUpBtn';
import Register              from 'Components/Register';
import ValidationExecute     from 'Components/Validation/ValidationExecute';
import { Sidenav }           from 'Components/Sidenav';
import { InvoiceConfirm }    from 'Components/InvoiceConfirm';
import { ConfirmAgain }      from 'Components/ConfirmAgain';
import { MobileNav }         from 'Components/MobileNav';
import { ToolTip }           from "Components/ToolTip";
import { TruncateElement }   from "Components/TruncateElement";
// import { DepartmentsModal }  from "Components/DepartmentsModal";
import { Planner }           from "Components/Planner/Planner";
import { Homepage }          from "Components/Homepage";
import { HomepageMap }       from 'Components/HomepageMap';
import { Product }           from "Components/Product/Product";
import { Newsletter }        from "Components/Newsletter";
import { Blog }              from "Components/Blog";
import { Footer }            from "Components/Footer";
import { Collections }       from "Components/Collections";
import { CityCode }          from "Components/CityCode";
import { SmartPhotoModule }  from "Components/SmartPhoto";
import { AddToCart }         from "Components/Cart/AddToCart";
import { FacebookPixelDynamicEvents} from "Components/SocialMedia/FacebookPixelDynamicEvents";
import { GoogleDataLayerDynamicEvents} from "Components/SocialMedia/GoogleDataLayerDynamicEvents";
import { EdroneDynamicEvents} from "Components/SocialMedia/EdroneDynamicEvents";
import { PWAAvailableToInstallPopup } from "Components/PWAAvailableToInstallPopup";
import { Promotions } from 'Components/Promotions';
import { CustomDropdownInitializer } from 'Components/CustomDropdown';

import '@fortawesome/fontawesome-free/js/fontawesome';
import '@fortawesome/fontawesome-free/js/solid';
import '@fortawesome/fontawesome-free/js/regular';
import '@fortawesome/fontawesome-free/js/brands';

const planner = new Planner();
planner.init();

selectric();

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.getRegistrations()
      .then(registrations => {
        registrations.forEach(registration => {
          registration.unregister()
        }) 
      })
    navigator.serviceWorker.register('/serviceWorker.js', {scope: '/'});
  });
}

export {
// @UNI-2
    // DepartmentsModule,
    // Sidebar,
    // Filters,
    Navbar,
    Infobar,
    ValidationModule,
    Favourites,
    // Cart,
    // CartOfferModule,
    LoginPanel,
    // Sort,
    ProductAvailable,
    ResetPassword,
    ScrollUpBtn,
    Register,
    ValidationExecute,
    Sidenav,
    InvoiceConfirm,
    ConfirmAgain,
    ReCaptcha,
    MobileNav,
    ToolTip,
    TruncateElement,
    // DepartmentsModal,
    Planner,
    Homepage,
    HomepageMap,
    Product,
    Newsletter,
    Blog,
    Footer,
    Collections,
    CityCode,
    SmartPhotoModule,
    AddToCart,
    FacebookPixelDynamicEvents,
    GoogleDataLayerDynamicEvents,
    EdroneDynamicEvents,
    PWAAvailableToInstallPopup,
    Promotions,
    CustomDropdownInitializer
};
import 'bootstrap/js/src/index';
import 'lazysizes';
import * as selectric from 'selectric';

// @UNI-1
import { ReCaptcha }         from 'Core/ReCaptcha';
import { Navbar }            from 'Components/Navbar';
import { Infobar }           from 'Components/Infobar';
// import { Filters }           from 'Components/Filters';
// import { Sort }              from 'Components/Sort';
import { ValidationModule }  from 'Components/Validation/Validation';
import { LoginPanel }        from 'Components/LoginPanel';
// import { Cart }              from 'Components/Cart/Cart';
// import { CartOfferModule }   from 'Components/Cart/CartOffer';
import { Favourites }        from 'Components/Favourites';
// import { DepartmentsModule } from 'Components/Departments';
import { ProductAvailable }  from 'Components/ProductAvailable';
import { ResetPassword }     from 'Components/ResetPassword';
import { ScrollUpBtn }       from 'Components/ScrollUpBtn';
import Register              from 'Components/Register';
import ValidationExecute     from 'Components/Validation/ValidationExecute';
import { Sidenav }           from 'Components/Sidenav';
import { InvoiceConfirm }    from 'Components/InvoiceConfirm';
import { ConfirmAgain }      from 'Components/ConfirmAgain';
import { MobileNav }         from 'Components/MobileNav';
import { ToolTip }           from "Components/ToolTip";
import { TruncateElement }   from "Components/TruncateElement";
// import { DepartmentsModal }  from "Components/DepartmentsModal";
import { Planner }           from "Components/Planner/Planner";
import { Homepage }          from "Components/Homepage";
import { HomepageMap }       from 'Components/HomepageMap';
import { Product }           from "Components/Product/Product";
import { Newsletter }        from "Components/Newsletter";
import { Blog }              from "Components/Blog";
import { Footer }            from "Components/Footer";
import { Collections }       from "Components/Collections";
import { CityCode }          from "Components/CityCode";
import { SmartPhotoModule }  from "Components/SmartPhoto";
import { AddToCart }         from "Components/Cart/AddToCart";
import { FacebookPixelDynamicEvents} from "Components/SocialMedia/FacebookPixelDynamicEvents";
import { GoogleDataLayerDynamicEvents} from "Components/SocialMedia/GoogleDataLayerDynamicEvents";
import { EdroneDynamicEvents} from "Components/SocialMedia/EdroneDynamicEvents";
import { PWAAvailableToInstallPopup } from "Components/PWAAvailableToInstallPopup";
import { Promotions } from 'Components/Promotions';
import { CustomDropdownInitializer } from 'Components/CustomDropdown';

import '@fortawesome/fontawesome-free/js/fontawesome';
import '@fortawesome/fontawesome-free/js/solid';
import '@fortawesome/fontawesome-free/js/regular';
import '@fortawesome/fontawesome-free/js/brands';

const planner = new Planner();
planner.init();

selectric();

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.getRegistrations()
      .then(registrations => {
        registrations.forEach(registration => {
          registration.unregister()
        }) 
      })
    navigator.serviceWorker.register('/serviceWorker.js', {scope: '/'});
  });
}

export {
// @UNI-2
    // DepartmentsModule,
    // Sidebar,
    // Filters,
    Navbar,
    Infobar,
    ValidationModule,
    Favourites,
    // Cart,
    // CartOfferModule,
    LoginPanel,
    // Sort,
    ProductAvailable,
    ResetPassword,
    ScrollUpBtn,
    Register,
    ValidationExecute,
    Sidenav,
    InvoiceConfirm,
    ConfirmAgain,
    ReCaptcha,
    MobileNav,
    ToolTip,
    TruncateElement,
    // DepartmentsModal,
    Planner,
    Homepage,
    HomepageMap,
    Product,
    Newsletter,
    Blog,
    Footer,
    Collections,
    CityCode,
    SmartPhotoModule,
    AddToCart,
    FacebookPixelDynamicEvents,
    GoogleDataLayerDynamicEvents,
    EdroneDynamicEvents,
    PWAAvailableToInstallPopup,
    Promotions,
    CustomDropdownInitializer
};
